import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DeleteConfirmationData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-deleteconfirmationdialog',
  standalone: false,
  templateUrl: './deleteconfirmationdialog.component.html',
  styleUrls: ['./deleteconfirmationdialog.component.css']
})
export class DeleteconfirmationdialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteconfirmationdialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationData
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
